import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

class Bar extends AbstractChart {
    protected allChartOptions(): Options {
        const yAxisLabels = $(this).data("y-axis-labels");
        const options: Options = {
            chart: {
                type: 'bar',
                height: 800,
                width: 700,
                marginBottom: 0,
                marginLeft: 490,
            },
            xAxis: {
                left: 400,
                labels: {
                    x: 0,
                    reserveSpace: false,
                    useHTML: false,
                    enabled: true,
                    style: {
                        fontSize: '6pt',
                    }
                },

            },
            yAxis: {
                opposite: true,
                left: 380,
                width: 235,
                labels: {
                    y: 0,
                    rotation: -90,
                    useHTML: true,
                    style: {
                        // fontSize: '6pt',
                        fontWeight: '500',
                        color: 'black'
                    },

                    formatter: function () {
                        function getLabelTextForValue(axesValue: string): string {
                            const value = parseFloat(axesValue);
                            switch (value) {
                                case 0:
                                    return value + ' <span class="option-label">sehr ungern</div>';
                                case 3:
                                    return value + ' <span class="option-label">sehr gern</div>';
                                default:
                                    return value.toString();
                            }
                        }

                        return yAxisLabels !== undefined ? yAxisLabels[this.value] : getLabelTextForValue(this.value.toString());
                    }
                },
                min: 0,
                max: 3,
                offset: 0,
                tickInterval: 0.5,
                title: {
                    text: null,
                },

            },
            plotOptions: {
                bar: {
                    groupPadding: 0.2,
                    pointPadding: 0,
                    dataLabels: {
                        enabled: false,
                    }
                }
            },
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

// noinspection JSUnusedGlobalSymbols
export default function () {
    registerPlugin(Bar)
}